import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, unref as _unref, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import Tabs from "@/components/Tabs/index.vue";
import TabPanel from "../components/Tabs/TabPanel.vue";
import { getAnnouncementOrNewsArticle } from "@/data";
import { useRoute, useRouter } from "vue-router";
import type { Article } from "@/data/index.type";
import { ref } from "vue";
import CombatArticle from "@/components/Article.vue";
import Banner from "@/components/Banner.vue";
import LicenseToken from "@/components/LicenseToken.vue";
import avatar from "../assets/contact-male-avatar.png";
import FloatingContact from "../components/FloatingContact.vue";
import { useStore } from "@/store";

export default /*#__PURE__*/_defineComponent({
  __name: 'AnnouncementDetails',
  setup(__props) {

const store = useStore();
const route = useRoute();
const router = useRouter();
const token = route.params["token"].toString();
const article = ref<Article>();
getAnnouncementOrNewsArticle(token).then((res) => {
  article.value = res.data.data;
});

const tab = () => {
  router.push({
    path: route.path.slice(0, route.path.lastIndexOf("/")),
    query: route.query,
  });
  return false;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Banner, {
      style: {"min-height":"80px"},
      src: "https://www.szjfjt.com/images/fbz.jpg",
      href: "https://www.fbz.com/",
      show: ""
    }),
    _createVNode(Tabs, { onTab: tab }, {
      default: _withCtx(() => [
        _createVNode(TabPanel, { title: "新闻动态公示" }, {
          default: _withCtx(() => [
            (article.value !== undefined)
              ? (_openBlock(), _createBlock(CombatArticle, {
                  key: 0,
                  data: article.value
                }, null, 8, ["data"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(LicenseToken),
    (_unref(store).state.contacts)
      ? (_openBlock(), _createBlock(FloatingContact, {
          key: 0,
          title: "在线咨询",
          qq: _unref(store).state.contacts[2],
          avatar: _unref(avatar)
        }, null, 8, ["qq", "avatar"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})